import React, { useContext } from 'react'
import { Route, Routes, Outlet } from 'react-router-dom';
import PaymentStatusPage from './pages/PaymentStatusPage'
import WizardPage_v2 from './pages/WizardPage_v2'
import Navbar from './components/Shared/Navbar/Navbar'
import FindALeaguePage from './pages/FindALeaguePage'
import NotificationsContext from './store/notifications-context'
import ErrorModal from './components/Shared/Modals/ErrorModal/ErrorModal'
import PrivateLayout from './components/Shared/Layouts/PrivateLayout'
import './App.css';
import LeagueInvitationAcceptancePage from './pages/LeagueInvitationAcceptancePage';

function App() {
  const notificationsCtx = useContext(NotificationsContext);

  return (
    <>
      <div className="container-app">
        <Navbar></Navbar>
        <div className="container container-content">
          <Routes>
            <Route element={<PrivateLayout><Outlet /></PrivateLayout>}>
              <Route path={'/paymentstatus'} element={<PaymentStatusPage />} />
              <Route path={'/register/:lid/:season/:slug'} element={<WizardPage_v2 />} />
              <Route path={'/invitation/:code'} element={<LeagueInvitationAcceptancePage/>} />
            </Route>
            <Route path="/:slug" element={<FindALeaguePage />} />
            <Route path="*" element={<FindALeaguePage />} />
          </Routes>
        </div>
        <div className="container my-1">
          <footer className="text-center text-lg-start text-secondary">
            <div className="text-center p-1">
              © {(new Date()).getFullYear()} United States Bowling Congress
            </div>
          </footer>
        </div>
      </div >
      <ErrorModal show={notificationsCtx.isShowModal === true} title={notificationsCtx.modalInfo.title} buttonText={notificationsCtx.modalInfo.buttonText}
        onButtonClick={() => notificationsCtx.hideModal()}>
        {notificationsCtx.modalInfo.body}
      </ErrorModal>
    </>
  );
}

export default App;
